import styled, { css } from 'styled-components';
// import { LayoutCSS, TypographyCSS, DesktopCSS, FormCSS } from 'insured-ui-styles';

/*const LogoImage = styled.img`
  ${DesktopCSS.LogoImageCSS};
  ${LayoutCSS.BlockDisplayCSS};
`;*/
const LogoImage = styled.img`
  max-width: 250px;
  max-height: 97px;
  margin: 0 auto;
  padding-top: 25px;
  display: block;
`;

/*const Wrapper = styled.div`
  ${TypographyCSS.PaleBlueBackgroundCSS};
  ${DesktopCSS.WrapperCSS};
`;*/
const Wrapper = styled.div`
  background-color: #f0fafc;
  font-family: 'Roboto', sans-serif;
`;

/*const BodyWrapper = styled.div`
  ${DesktopCSS.BodyWrapperCSS};
`;*/
const BodyWrapper = styled.div`
  padding: 15px 25px;
  width: 80%;
  margin: auto;
`;

/*const FormWrapper = styled.form`
  ${DesktopCSS.BodyWrapperCSS};
`;*/
const FormWrapper = styled.form`
  padding: 15px 25px;
  width: 80%;
  margin: auto;
`;

/*const BodyWrapperAlignedCentered = styled.div`
  ${DesktopCSS.BodyWrapperCSS};
  text-align: center;
`;*/
const BodyWrapperAlignedCentered = styled.div`
  padding: 15px 25px;
  width: 80%;
  margin: auto;
  text-align: center;
`;

/*const Input = styled.input`
  ${DesktopCSS.InputCSS};
  ${TypographyCSS.DeepBlueCSS};
  &::placeholder {
    ${FormCSS.InputPlaceholderCSS};
  }
  &:focus {
    ${FormCSS.InputFocusCSS};
  }
`;*/
const Input = styled.input`
  border-bottom-color: #6f929a !important;
  color: #022c35;
  ::placeholder {
    font-style: Italic !important;
    color: #6f929a !important;
  }
  :focus {
    color: #022c35 !important;
    border-bottom-color: #6f929a !important;
  }
`;

/*const InputAddon = styled.span`
  background: transparent;
  ${TypographyCSS.DeepBlueCSS};
`;*/
const InputAddon = styled.span`
  background: transparent;
  color: #022c35;
`;

/*const Button = styled.button`
  width: 100%;
  ${TypographyCSS.WhiteCss};
  ${TypographyCSS.BrightBlueBackgroundCSS};
  ${DesktopCSS.ButtonCSS};
  ${LayoutCSS.BlockDisplayCSS};
  &:hover,
  &:focus {
    ${TypographyCSS.WhiteCss};
    opacity: 0.8;
  }
`;*/
const Button = styled.button`
  width: 100%;
  color: #fff;
  background-color: #0672b2;
  border-radius: 2px;
  margin: 25px auto 5px;
  display: block
  &:hover,
  &:focus {
    color: #fff;
    opacity: 0.8;
  }
`;

/*const HalfCenteredButton = styled.button`
  width: 50%;
  ${TypographyCSS.WhiteCss};
  ${TypographyCSS.BrightBlueBackgroundCSS};
  border-radius: 2px;
  ${LayoutCSS.BlockDisplayCSS};
  &:hover,
  &:focus {
    ${TypographyCSS.WhiteCss};
    opacity: 0.8;
  }
  margin: auto;
`;*/
const HalfCenteredButton = styled.button`
  width: 50%;
  color: #fff;
  background-color: #0672b2;
  border-radius: 2px;
  display: block
  &:hover,
  &:focus {
    color: #fff;
    opacity: 0.8;
  }
  margin: auto;
`;

/*const ErrorDiv = styled.div`
  ${DesktopCSS.ErrorDiv} ${FormCSS.ErrorText};
  ${props =>
    props.accepted === true &&
    css`
      ${FormCSS.ErrorTextAccepted};
    `};
`;*/
const ErrorDiv = styled.div`
  font-size: 14px;
  color: #6f929a;
  font-style: normal;
  ${props =>
    props.accepted === false &&
    css`
      color: #ff0000;
      font-style: italic;
    `};

  ${props =>
    props.accepted === true &&
    css`
      color: #68c007;
      font-style: normal;
    `};
`;

/*const PwErrorDiv = styled.div`
  ${FormCSS.PasswordMismatchedCSS};
`;*/
const PwErrorDiv = styled.div`
  font-size: 14px;
  color: #ff0000;
`;

/*const Link = styled.a`
  ${FormCSS.LinkCSS};
`;*/
const Link = styled.a`
  color: #0672b2;
`;

const IndicatorDotContainer = styled.div`
  text-align: center;
  padding-top: 10px;
`;

/*const IndicatorDot = styled.span`
  ${LayoutCSS.IndicatorDotCSS};
  ${props =>
    props.active === true &&
    css`
      ${LayoutCSS.IndicatorDotActiveCSS};
    `};
`;*/
const IndicatorDot = styled.span`
  height: 10px;
  width: 10px;
  background-color: #b5d6e7;
  border-radius: 5px;
  margin: 2px;
  display: inline-block;
  ${props =>
    props.active === true &&
    css`
      background-color: #70afd0;
    `};
`;

export {
  LogoImage,
  BodyWrapper,
  FormWrapper,
  BodyWrapperAlignedCentered,
  Input,
  InputAddon,
  Button,
  HalfCenteredButton,
  ErrorDiv,
  PwErrorDiv,
  Link,
  Wrapper,
  IndicatorDotContainer,
  IndicatorDot,
};
